var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3405_856)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3405_856",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3405_856",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3405_856",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUNJREFUSA3FlK1OQ0EQhT+BQCAQSAQCUYlAIpEIBBJZgazkPTAIBAJBAgJRSdIKJAmiAgGisgmCR4B7bpZksjuzFd2Gk0wye+b37s5c+Ee8AZK14Bh4TSK9Oe6AURLpTbEFfAM7SaSLa4Zz4MlkGwPimuEZODPZpItrgt10PZsmm/QvQLaVcQlcO1luANlWxnt3HUdOFnEzh4+oDeAiNx52j/mZk+Ys24E511R97TR3uAJ+loh8lkGNFm+mTxK5V4neTz7yjaB9+cimsPc9BV6iKMPL58Scc1XDICnwCAwLtiTkc1/SPaN9Uffu1s+B7SDQ0vKRbw7tiK5Y998cepNJqz3xuvsbydrje3E9p2WpBbojGWZzDHr8h6BIOJJOnpBS91GRcCTDbIHBK1IdySBPlbZFBusaSRW57f6SC+9PGbX3C/W3PmgY/ipCAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextValidation);
export default __webpack_public_path__ + "static/media/text-validation.e887f824912046cdc1d8e6f9a90e6344.svg";
export { ForwardRef as ReactComponent };